"use strict";
// @ts-nocheck
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
exports.__esModule = true;
var React = __importStar(require("react"));
;
function xsg(_a) {
    var size = _a.size, _b = _a.color, color = _b === void 0 ? "currentColor" : _b;
    return React.createElement("svg", { width: size, height: size, viewBox: "0 0 24 24", fill: "none" },
        React.createElement("path", { d: "M12.1226 4.71525V2.57401L20.0921 7.173L18.2494 8.244L12.1226 4.71525ZM18.3716 15.528V8.472L20.2324 7.401V16.599L18.3724 15.528H18.3716ZM12.1226 19.2848L18.2494 15.7568L20.0921 16.827L12.1226 21.426V19.2848ZM3.89064 16.827L5.75064 15.7568L11.8594 19.2848V21.426L3.89064 16.827ZM3.76764 7.401L5.61039 8.472V15.528L3.76764 16.599V7.401ZM3.89064 7.173L11.8594 2.57401V4.71525L5.75139 8.244L3.89064 7.173ZM12.0086 4.917L5.86539 8.4465V15.5378L12.0086 19.0838L18.1346 15.5378V8.4465L12.0086 4.91775V4.917ZM16.9414 11.2545L16.6781 11.7105L14.9231 10.728L12.6761 11.991L14.9224 13.2548L16.6774 12.2723L16.9414 12.7283L15.4669 13.5533L16.9414 14.3783L16.6781 14.835L15.2036 14.01V15.66H14.6591V13.7115L12.4129 12.4478V14.9753L14.1506 15.9405L13.8874 16.3883L12.4129 15.5633V17.2133H11.8676V15.5633L10.3931 16.3883L10.1126 15.9323L11.8676 14.9663V12.4478L9.62064 13.7115V15.66H9.05889V14.01L7.60239 14.835L7.32114 14.3783L8.79564 13.5533L7.32114 12.7283L7.60239 12.2723L9.34014 13.2548L11.6044 11.991L9.33939 10.7273L7.60239 11.7098L7.32114 11.2538L8.79564 10.4288L7.32114 9.60375L7.60239 9.14775L9.05889 9.97275V8.31375H9.62139V10.2623L11.8676 11.526V9.0075L10.1299 8.0415L10.3931 7.5855L11.8676 8.4105V6.7605H12.4121V8.4105L13.8866 7.5855L14.1491 8.0415L12.4121 9.0075V11.535L14.6584 10.2713V8.31375H15.2029V9.96375L16.6774 9.13875L16.9399 9.5955L15.4661 10.4205L16.9406 11.2538L16.9414 11.2545Z", fill: color }));
}
exports["default"] = xsg;
//# sourceMappingURL=xsg.js.map